export const MUI_LIMIT_DATE_PICKER_MIN_DATE = new Date(1900, 0, 1);
export const MUI_LIMIT_DATE_PICKER_MAX_DATE = new Date(2099, 11, 31, 23, 59);
